module.exports = __webpack_public_path__ + "static/media/us-flag.438f7005.png";